import {Annotation} from "../../../domain/entities/entities";
import {AnnotationRepository} from "../repository";
import http from "../http/index";
import {wrapErrorHandler} from "../utils/wrap_error_handler";

class _AnnotationRepository implements AnnotationRepository {
  listAnnotations(contentID: number): Promise<Annotation[]> {
    return wrapErrorHandler<Annotation[]>(async () => {
      const response = await http.get(`/api/decola/annotation/list/${contentID}`);
      return response.data.annotation;
    });
  }

  async saveAnnotation(payload: any): Promise<Annotation> {
    return wrapErrorHandler<Annotation>(async () => {
      const response = await http
        .post(`/api/decola/annotation/create/${payload.content_id}`, {
          annotation: payload.annotation,
        });
      return response.data.annotation;
    });
  }

  async editAnnotation(annotation: Annotation): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      const response = await http
        .post(`/api/decola/annotation/edit/${annotation.id}`, {
          annotation: annotation,
        });
      return response.data;
    });
  }

  async deleteAnnotation(annotation: Annotation): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      const response = await http.delete(`/api/decola/annotation/delete/${annotation.id}`);
      return response.data;
    });
  }
}

export const interfaceAnnotationRepository: AnnotationRepository = new _AnnotationRepository();
